module.exports = __webpack_public_path__ + "static/media/hamaca.ab7ec429.jpg";